import BaseApi from './base.api';

export interface NomenclatureLabel {
  code: string;
  label: string | null;
}

export interface PreventiveActivity {
  nomenclature: string;
  codes: NomenclatureLabel[];
  specialties: NomenclatureLabel[];
  description: string | null;
  nrns: string[];
  done: boolean;
}

export interface PreventivePlan {
  id: string;
  plannedType: string;
  plannedCategory: number | null;
  plannedStatus: number;
  fromDate: string | null;
  toDate: string | null;
  activities: PreventiveActivity[];
}

export interface PreventiveResponse {
  /** When this preventive data was last pulled from НЗИС (L009 sync). */
  lastSyncedAt: string | null;
  /** When the next periodic refresh is scheduled. */
  nextRefreshAt: string | null;
  plans: PreventivePlan[];
}

class PreventiveApi extends BaseApi {
  /** Decoded preventive plans + activities for one patient, plus sync timestamps. */
  async getPatientPreventivePlans(patientId: number): Promise<PreventiveResponse> {
    return this.get(`/patients/${patientId}/preventive`);
  }
}

export const preventiveApi = new PreventiveApi();
